import React, {useState} from "react"
import {ChartScopePeriod, ChartScopeSettings, displayPeriod, getChartScopeDisplayValue} from "./chart-scope-settings"
import InsightDataHelper from "../insight-data-helper"
import {ChartScopeButtons} from "./chart-scope-buttons"
import {SelectableValue} from "./selectable-value/selectable-value"
import {RadioButton, RadioButtonGroup} from "../../../../components-shared/radio-button/radiobutton"

export interface ChartScopeProps {
  chartScopeSettings: ChartScopeSettings
  spendingData: InsightDataHelper | null
  setChartScopeSettings: (chartScopeSettings: ChartScopeSettings) => void
  className?: string
}

export const ChartScope: React.FC<ChartScopeProps> = ({ chartScopeSettings, spendingData, setChartScopeSettings,className, children }) => {
  const [showChartScopeButtons, setShowChartScopeButtons] = useState<boolean>(false)
  const [showPeriod, setShowPeriod] = useState<boolean>(false)

  const selectChartScope = (chartScopeSettings: ChartScopeSettings) => {
    setChartScopeSettings(chartScopeSettings)
    setShowChartScopeButtons(false)
  }

  const changePeriod = (period: ChartScopePeriod) => {
    const isActuallyChanged = period !== chartScopeSettings.period
    setChartScopeSettings({...chartScopeSettings, period})
    if (isActuallyChanged) setShowPeriod(false)
  }

  return <div className={className}>
    Toon
    <SelectableValue isExpanded={showChartScopeButtons} onSetExpanded={setShowChartScopeButtons}>
      {getChartScopeDisplayValue(chartScopeSettings)}
    </SelectableValue>
    per
    <SelectableValue isExpanded={showPeriod} onSetExpanded={setShowPeriod}>
      {displayPeriod[chartScopeSettings.period]}
    </SelectableValue>

    {children}

    {showChartScopeButtons && spendingData && <ChartScopeButtons chartScopeSettings={chartScopeSettings} setChartScopeSettings={selectChartScope}/>}
    {showPeriod && <RadioButtonGroup validationResult={{valid: true}}>
      <RadioButton name="existingRuleBehaviour" value="DeleteExistingRule" checked={chartScopeSettings.period === "month"} label="Per maand" onChange={() => changePeriod("month")}/>
      <RadioButton name="existingRuleBehaviour" value="AddHigherPriorityRule" checked={chartScopeSettings.period === "year"} label="Per jaar" onChange={() => changePeriod("year")}/>
    </RadioButtonGroup>}
  </div>
}